"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @file
 * R4V Percentage Bars.
 */
(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.r4vBars = {
    attach: function attach(context, settings) {
      $('body', context).once('r4v-bars').each(function () {
        if (settings.hasOwnProperty('bar_values')) {
          for (var id in settings.bar_values) {
            useHighChart(id, settings.bar_values[id]);
          }
        }
      });
    }
  };
  Drupal.behaviors.r4vPie = {
    attach: function attach(context, settings) {
      $('body', context).once('r4v-pie').each(function () {
        if (settings.hasOwnProperty('pie_values')) {
          for (var id in settings.pie_values) {
            useHighChartPie(id, settings.pie_values[id]);
          }
        }
      });
    }
  };

  function useHighChartPie(elementId, values) {
    var data = [];
    var current;
    var pieValue;
    var percent;

    for (var i = 0; i < values.series.length; i++) {
      current = values.series[i];
      pieValue = parseInt(current.value);
      percent = Math.round(pieValue / values.total * 100) + '';
      data.push({
        description: current.description,
        formatedValue: current.format,
        percent: percent,
        tName: Drupal.t('Value'),
        color: values.colors[i],
        legend: values.legends[i] ? values.legends[i] : 'valor',
        y: pieValue,
        z: 15,
        dataLabels: {
          format: "\n          <div style=\"color:{point.color}\" class=\"stat stat--vertical align-items-center text-center\">\n            <div class=\"stat__percentage\">{point.percent}%</div>\n            <div class=\"stat__figure\">{point.formatedValue}</div>\n            <span class=\"stat__subtext c-dark-blue\">{point.description}</span>\n          </div>\n          ",
          useHTML: true,
          verticalAlign: 'top'
        }
      });
    }

    Highcharts.chart(elementId, {
      chart: {
        type: 'variablepie',
        height: 9 / 16 * 100 + '%'
      },
      title: {
        text: ''
      },
      tooltip: {
        enabled: true,
        headerFormat: '',
        pointFormat: "\n          <span style=\"color:{point.color}\">\u25CF</span> {point.legend}: <b>{point.formatedValue}</b>\n        ",
        style: {
          fontFamily: 'Roboto'
        }
      },
      series: [{
        minPointSize: 10,
        innerSize: '45%',
        zMin: 0,
        data: data
      }],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 680
          },
          chartOptions: {
            series: {
              dataLabels: {
                enabled: false
              }
            }
          }
        }]
      }
    });
  }
  /**
   * Helper function to add a Highchart functionality to the provided element.
   */


  function useHighChart(elementId, values) {
    var series = [];
    var showPrefixes = values.showPrefix;
    var remainingValue = values.max;

    for (var i = 0; i < values.series.length; i++) {
      var barValue = parseInt(values.series[i].data);
      series.push({
        name: values.series[i].name,
        data: [barValue],
        index: values.series.length - i - 1,
        dataLabels: {
          color: values.colors[i]
        }
      });
      remainingValue -= barValue;
    } // Push remaining bar.


    series.push({
      name: 'remaining',
      data: [remainingValue],
      index: -1,
      dataLabels: {
        color: '#7e7e7e',
        align: 'left'
      }
    });
    Highcharts.chart(elementId, {
      chart: {
        type: 'bar',
        height: 50,
        spacing: [0, 0, 0, 0]
      },
      tooltip: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      colors: values.colors,
      exporting: false,
      title: {
        text: ''
      },
      xAxis: {
        height: 35,
        labels: {
          enabled: false
        },
        categories: [''],
        lineWidth: 0
      },
      yAxis: {
        min: 0,
        max: values.max,
        endOnTick: false,
        title: {
          text: ''
        },
        labels: {
          enabled: false
        },
        gridLineWidth: 0
      },
      plotOptions: {
        bar: {
          stacking: 'normal',
          events: {
            legendItemClick: function legendItemClick(e) {
              e.preventDefault();
            }
          },
          dataLabels: _defineProperty({
            align: 'left',
            enabled: true,
            color: '#000',
            style: {
              fontWeight: 'bolder',
              fontSize: '16px'
            },
            formatter: function formatter() {
              return formatBarLabel(this.y, showPrefixes);
            },
            y: 35
          }, "style", {
            fontFamily: 'Dosis'
          })
        }
      },
      series: series
    });
  }

  function formatBarLabel(value, showPrefixes) {
    var simbol = [{
      value: 1,
      symbol: ''
    }, {
      value: 1E3,
      symbol: 'k'
    }, {
      value: 1E6,
      symbol: 'M'
    }];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;

    for (i = simbol.length - 1; i > 0; i--) {
      if (value >= simbol[i].value) {
        break;
      }
    }

    var formatedNumber = (value / simbol[i].value).toFixed(1).replace(rx, "$1") + simbol[i].symbol;

    if (showPrefixes && showPrefixes === '1') {
      formatedNumber = '$' + formatedNumber;
    }

    return formatedNumber;
  }
})(jQuery, Drupal);